import {
  defaultFilterKeys,
  defaultLinearDatasetOptions,
  defaultLinearFilters,
  defaultLinearOptions,
  getCssColor,
  getFormatedDate,
  getGroupedData,
  today,
} from '@/utils/analytics'

/**
 * @param {vueInstance} context - This.
 * @returns {LinearChart} The chart configuration object.
 */
export default function (context) {
  return {
    key: 'status_purchase',
    resource: {
      endpoint: 'status_purchase',
      filter: {
        'filter.start': defaultFilterKeys[30],
        'filter.end': today(),
        'filter.statuses': ['sold'],
      },
    },
    type: 'Linear',
    title: {
      id: 'status_purchase',
      label: `${context.$t('statisticsSalesResidentials')}`,
      icon: '',
      style: true,
    },
    filterBy: {
      initial: 30,
      label: context.$t('select'),
      key: 'filter.start',
      values: defaultLinearFilters.map(filter => ({ ...filter, label: context.$t(filter.label) })),
    },
    total: ({ data = {} }) => ({ purchase_total: data.total }),
    dimensions: [
      {
        id: 'purchase_total',
        label: `${context.$t('addonBid')} ${context.$tc('total', 2).toLowerCase()}`,
        icon: '',
        marker: getCssColor('primary'),
        backgroundColor: getCssColor('primary', 0.5),
        borderColor: getCssColor('primary'),
        value: ({ data = {} }) => (data.keys ? data.keys.map(i => data.values[i].total) : []),
      },
      {
        id: 'purchase_by_date',
        label: context.$t('purchaseByDate'),
        icon: '',
        marker: getCssColor('error'),
        backgroundColor: getCssColor('error', 0.5),
        borderColor: getCssColor('error'),
        value: ({ data = {} }) => (data.keys ? data.keys.map(key => getGroupedData(data, key)) : []),
      },
    ],
    colors: {},
    options: ({ source }) => ({
      ...defaultLinearOptions({ source }),
    }),
    data: ({ data = {}, dimensions = [] }) => {
      // TODO: Refactor to custom func if reused all the places, dimension.value is the same for all
      const labels = data.keys ? data.keys.map(key => getFormatedDate(key)) : []
      return {
        labels,
        datasets: dimensions.map(dimension => {
          return {
            ...defaultLinearDatasetOptions,
            data: dimension.value({ data }),
            backgroundColor: dimension.backgroundColor,
            borderColor: dimension.borderColor,
          }
        }),
      }
    },
  }
}
